import styled from 'styled-components';
import { Colors } from '~/config/Colors';
import Button from '~/pages/Sistema/componentes/Button';
import { Scrollbars } from 'react-custom-scrollbars';

export const Container = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  height: calc(100% - 5.5em);

  .content-oc {
    width: 100%;
    height: 34em;
    padding: 0.65em;
  }

  .div-icone {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    background: ${Colors.Color26};
    border-radius: 0.4rem;
    padding: 0.15rem 0.8rem 0.15rem 0.3rem;
    width: fit-content;

    img {
      width: 1.4rem;
    }

    .title {
      font-size: 0.7125rem;
      font-weight: 700;
      color: ${Colors?.Color7};
      margin-left: 0.5rem;
    }
  }

  .header-content {
    display: flex;
    justify-content: space-between;
    flex-direction: row;
    width: 100%;
    align-items: center;
    margin-bottom: 0;
    box-shadow: 0px 7px 7px rgb(0 0 0 / 6%);
    border-radius: 1rem 1rem 0 0;
    padding: 0.6rem 1rem 0.6rem 1rem;

    .div-filtro {
      display: flex;
      justify-content: flex-end;
      flex-direction: row;
      align-items: center;

      .item {
        margin-left: 0.8rem;

        .btn-excel {
          height: 1.8rem;
          width: 1.8rem;
          padding: 0rem;
          font-size: 0.88rem;
          font-weight: 600;
          background: ${Colors.Color4};
          border: 0.25rem solid ${Colors.Color4};
          border-radius: 0.4rem;
          color: #FFFFFF;
          display: flex;
          justify-content: center;
          align-items: center;

          img {
            width: 1rem;
          }
        }
      }
    }
  }

  .sessao-alerta {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    width: 100%;
  }

  .sessao-quantidade {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    
    .color1 {
      color: #9747FF;
    }
    
    .color2 {
      color: #4D78AD;
    }
    
    .color3 {
      color: #339C89;
    }
    
    .color4 {
      color: #99396D;
    }
    
    .color5 {
      color: #399948;
    }
    
    .item-quantidade.ativo {
      border: 2px solid ${Colors.Color1};
    }

    .item-quantidade {
      width: 13.5rem;
      height: 4.6rem;
      background: ${Colors.Color23};
      margin-bottom: 1rem;
      margin-right: 1rem;
      border-radius: 0.9rem;
      padding: 1.3rem 1.5rem;
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: space-between;
      cursor: pointer;

      .item-right {
        display: flex;
        flex-direction: row;
        align-items: flex-start;
        justify-content: space-between;

        .item-numero {
          display: flex;
          height: 100%;
          align-items: center;
          position: relative;
          justify-content: center;

          h5 {
            position: absolute;
            top: 22%;
            font-size: 1.2rem;
          }
        }
      }
      
      .item-left {
        margin-right: 0.8rem;

        .pre-titulo-body {
          font-size: 0.7rem;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          width: 100%;
          font-weight: 600;
        }

        .titulo-body {
          font-size: 0.75rem;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          width: 100%;
          font-weight: 800;
          color: #8F9DAF;
        }
      }
    }
  }
`;

export const SectionProjeto = styled.div`
  position: relative;
  width: 100%;
  min-height: 2rem;
  margin-top: 2rem;
  border-radius: 0.9375rem;
  //padding: 1.25rem;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  //background: ${Colors.Color13};
`;

export const ThisCard = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 1rem;

  .card-item {
    cursor: pointer;
    padding: 0.8rem 1.4rem;
    border-radius: 1rem;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    width: 100%;
    height: ${props => props?.height ? props?.height : "6.5rem"};
    position: relative;
    overflow: hidden;
    background: ${localStorage.getItem("tema") == "E" ? Colors.Color23 : Colors.Color23};
    box-shadow: none !important;

    ${props => {
      if (props?.ativo) {
        return `border: 0.1em solid ${Colors.Color8};`;
      }
    }}

    .top {
      display: flex;
      flex-direction: row;
      justify-content: space-between;

      .content-top {
        display: flex;
        flex-direction: column;

        .card-cod {
          background: ${Colors.Color4};
          border-radius: 0.4rem;
          padding: 0.2rem 0.6rem;
          display: flex;
          flex-direction: row;
          align-items: center;
          justify-content: center;
          width: 3rem;

          .cod {
            font-size: 0.7rem;
            font-weight: bold;
            color: ${Colors.Color23};
          }
        }

        .card-top {
          margin-top: 0.8rem;
          line-height: 0.9rem;

          .titulo {
            font-size: 0.8rem;
            font-weight: bold;
            color: ${Colors.Color4};
            max-width: 36rem;
          }

          .analista {
            font-size: 0.7rem;
            font-weight: 600;
            color: ${Colors.Color14};
            margin-top: 1rem;
          }
        }
      }

      .content-status {
        display: flex;
        flex-direction: row;
        align-items: flex-start;
        justify-content: flex-end;
        height: 1.5rem;
        width: 10rem;

        .item-status {
          display: flex;
          flex-direction: row;
          align-items: center;

          .circle {
            border-radius: 1rem;
            content: "";
            width: 0.5rem;
            height: 0.5rem;
            background: #AA2B2B;
            margin-right: 0.4rem;
          }

          p {
            font-size: 0.6rem;
            font-weight: 700;
            color: ${Colors.Color14};
          }
        }
      }

      .content-progress {
        display: flex;
        flex-direction: column;
        align-items: flex-end;
        justify-content: flex-start;
      }

      .card-content {
        display: flex;
        flex-direction: row;
        align-items: center;
        margin-top: 0.6rem;

        .titulo {
          font-size: 0.7rem;
          font-weight: bold;
          color: ${Colors.Color14};
          margin-left: 0.5rem;
        }

        .progress {
          width: 20rem;
          margin-left: 0.5rem;
          border-radius: 1rem;
          background: ${localStorage.getItem("tema") == "E" ? "#1D1D1D" : Colors.Color2};
          height: 1rem;
        }

        .progress.atraso {
          background: rgb(255 118 118) !important;
        }
      }

      .content-os {
        margin-top: 0.6rem;
        display: flex;

        .info {
          display: flex;
          flex-direction: row;
          align-items: center;

          .item-info {
            display: flex;
            flex-direction: row;
            align-items: center;
            height: fit-content;
            margin-left: 1.5rem;
            
            .estourado {
              content: "";
              display: flex;
              width: 0.8rem;
              height: 0.8rem;
              border-radius: 1rem;
              background: rgb(255 118 118);
            }

            .atraso {
              content: "";
              display: flex;
              width: 0.8rem;
              height: 0.8rem;
              border-radius: 1rem;
              background: rgb(182 177 18);
            }

            .normal {
              content: "";
              display: flex;
              width: 0.8rem;
              height: 0.8rem;
              border-radius: 1rem;
              background: #339C89;
            }

            .data {
              font-size: 0.6rem;
              font-weight: bold;
              color: ${Colors.Color14};
              margin-left: 0.5rem;
            }
          }
        }
      }
    }

  }

  .card-subitem {
    background: ${localStorage.getItem("tema") == "E" ? Colors.Color27 : "#FFFFFF"};
    width: 96%;
    border-radius: 0 0 1rem 1rem;
    padding: 1rem;
  }
`;

export const ThisButton = styled(Button)`
  height: 1.8rem;
  width: 1.8rem;
  padding: 0rem;
  font-size: 0.88rem;
  font-weight: 600;
  background: ${Colors.Color4};
  border: 0.25rem solid ${Colors.Color4};
  border-radius: 0.4rem;
  color: #FFFFFF;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-left: 1rem;

  img {
    width: 1rem;
  }
`;

export const ThisCardItem = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-bottom: ${(props) => props?.cabecalho ? "1em" : "0.5em"};
  background: ${(props) => props?.cabecalho ? Colors.Color4 : localStorage.getItem("tema") == "E" ? Colors.Color13 : Colors.Color2};
  height: 2.6rem;
  padding: 0em 1rem;
  border-radius: 0.7rem;

  .col {

    p {
      font-size: 0.8rem;
      font-weight: 700;
      color: ${(props) => props?.cabecalho ? Colors?.Color9 : Colors?.Color14};
      margin-left: 0.5rem;
    }

    .content-progress {
      display: flex;
      flex-direction: column;
      align-items: flex-end;
      justify-content: flex-start;
    }

    .card-content {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: flex-end;
      width: 100%;

      .titulo {
        font-size: 0.7rem;
        font-weight: bold;
        color: ${Colors.Color14};
        margin-left: 0.5rem;
      }

      .progress {
        width: 75%;
        margin-left: 0.5rem;
        border-radius: 1rem;
        background: ${localStorage.getItem("tema") == "E" ? "#1D1D1D" : "#FFFFFF"};
        height: 1rem;
      }
    }
  }

  .center {
    text-align: center;
  }

  .col1 {
    width: 5rem;
  }

  .col2 {
    width: 10rem;
  }

  .col2-2 {
    width: 12rem;
  }

  .col3 {
    width: 15rem;
  }

  .col3-2 {
    width: 17rem;
  }

  .col4 {
    width: 20rem;
  }

  .col4-2 {
    width: 22rem;
  }

  .col5 {
    width: 25rem;
  }
`;

export const ThisProgress = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  content: "";
  width: ${props => props?.width};
  height: 0.9rem;
  border-radius: 1rem;
  background: ${props => props?.backgound};
`;

export const SectionProjetoAlerta = styled.div`
  position: relative;
  width: 55%;
  min-height: 2rem;
  margin-top: 2rem;
  border-radius: 0.9375rem;
  padding: 1.25rem;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  background: ${Colors.Color13};

  .div-icone {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    background: ${Colors.Color2};
    border-radius: 0.4rem;
    padding: 0.15em 0.8em 0.15em 0.3rem;
    width: fit-content;
    margin-bottom: 1.5rem;

    img {
      width: 1.4rem;
    }

    .title {
      font-size: 0.7125rem;
      font-weight: 700;
      color: ${Colors?.Color7};
      margin-left: 0.5rem;
    }
  }

  .div-list {
    height: 20rem;
    overflow: auto;
  }
`;

export const ScrollOS = styled(Scrollbars)`
  width: calc(100%) !important;

  .display-oc {
    display: flex;
    flex-wrap: wrap;
    flex-direction: row;
    width: max-content;
  }
`;
